module.exports = __webpack_public_path__ + "img/analytics-marketing-team-5.d4d53a15.svg";